import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import Mission from './components/Mission';
import Impact from './components/Impact';
import Gallery from './components/Gallery';
import GetInvolved from './components/GetInvolved';
import Footer from './components/Footer';
import About from './pages/About';
import Contact from './pages/Contact';
import Missions from './pages/Missions';
import GalleryPage from './pages/GalleryPage';
import './App.css';

function Home() {
  return (
    <>
      <Hero />
      <Mission />
      <Impact />
      <Gallery />
      <GetInvolved />
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Navigation />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/missions" element={<Missions />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;

